import { Injectable } from '@angular/core';

// Chiave API Google Maps (prima era in app.module, usata da AgmCoreModule.forRoot).
export const GOOGLE_API_KEY = 'AIzaSyBvkK6SN669qyITSX4zFJLdC-cXV2fSEd0';

/**
 * Carica lo script JS di Google Maps on-demand. Sostituisce MapsAPILoader di @agm/core
 * (rimosso in Phase 3d): @angular/google-maps non carica l'API da sé.
 */
@Injectable({
	providedIn: 'root'
})
export class GoogleMapsLoaderService {

	private loadPromise: Promise<void> | null = null;

	load(): Promise<void> {
		if (this.loadPromise) {
			return this.loadPromise;
		}
		if ((window as any).google && (window as any).google.maps) {
			this.loadPromise = Promise.resolve();
			return this.loadPromise;
		}
		this.loadPromise = new Promise<void>((resolve, reject) => {
			const script = document.createElement('script');
			script.src = 'https://maps.googleapis.com/maps/api/js?key=' + GOOGLE_API_KEY;
			script.async = true;
			script.defer = true;
			script.onload = () => resolve();
			script.onerror = (err) => reject(err);
			document.head.appendChild(script);
		});
		return this.loadPromise;
	}
}
